import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-illustrations.css';
var getClassNameList = classNames.bind(styles);
var UitkIllustrations = function (props) {
  var className = props.className,
    alt = props.alt,
    url = props.url;
  var cssClassNames = getClassNameList('uitk-illustration', className);
  return url ? React.createElement("img", {
    className: cssClassNames,
    alt: alt,
    src: url
  }) : null;
};
UitkIllustrations.displayName = 'UitkIllustrations';
export { UitkIllustrations };